  <div class="hobbies">
    <div class="hobby pop" [class.selected]="hobby.selected" [ngClass]="['hobby-' + hobby.id]"
      (click)="selectUnselectHobby(hobby.id)" *ngFor="let hobby of me.hobbies">
      <mat-icon svgIcon="HOBBY_{{hobby.id}}"></mat-icon>
      <span>{{hobby.name}}</span>
    </div>
  </div>
